import styled from "styled-components";
import { createContext, useState, useEffect } from "react";
import { listenToCheatSheets } from "../Firebase";

export const CheatSheetContext = createContext<CheatSheetsContext>({
  cheatSheets: [],
  getAllCheatSheets: () => {},
});

export default function CheatSheetsContextProvider(props: Props) {
  const [cheatSheets, setCheatSheets] = useState<CheatSheet[]>([]);
  const [getCheatSheets, setGetCheatSheets] = useState<boolean>(false);
  const [unsubscribeFromCheatSheets, setUnsubscribeFromCheatSheets] = useState<
    () => void
    >(() => () => {});

  useEffect(() => {
    if (!getCheatSheets) return;
    const unsubscribeFromCheatSheets = listenToCheatSheets(
      (cheatCheatsData) => {
        //order by title
        cheatCheatsData.sort((a, b) => {
          if (a.title < b.title) {
            return -1;
          }
          if (a.title > b.title) {
            return 1;
          }
          return 0;
        });
        cheatCheatsData && setCheatSheets([...cheatCheatsData]);
      }
    );

    setUnsubscribeFromCheatSheets(() => unsubscribeFromCheatSheets);

  }, [getCheatSheets]);

  useEffect(() => {
    return () => {
      unsubscribeFromCheatSheets();
    };
  }, []);

  function getAllCheatSheets() {
    setGetCheatSheets(true);
  }

  return (
    <CheatSheetContext.Provider
      value={{
        getAllCheatSheets: getAllCheatSheets,
        cheatSheets: cheatSheets,
      }}
    >
      {props.children}
    </CheatSheetContext.Provider>
  );
}

interface CheatSheetsContext {
  cheatSheets: CheatSheet[];
  getAllCheatSheets: () => void;
}

interface Props {
  children: React.ReactNode;
}
